import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "store";
import router from "../../../router";

// 创建axios实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // url基础地址，解决不同数据源url变化问题
    // withCredentials: true, // 跨域时若要发送cookies需设置该选项
    // timeout: 120000 // 超时
});

// service.defaults.baseURL = "http://yeying360.ts";
service.defaults.baseURL = "https://api.yeain360.com";
// service.defaults.baseURL = "http://api.yeying360.com";
// service.defaults.baseURL = "https://yeyingapi.troyzhou.com";
service.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';//配置请求头信息。

// 请求拦截
service.interceptors.request.use(
    config => {
        // do something
        const token = localStorage.getItem('token')
        if (token) {
            // 设置令牌请求头
            config.headers["Authorization"] = 'Bearer ' + token;
        }
        return config;
    },
    error => {
        // 请求错误预处理
        //console.log(error) // for debug
        return Promise.reject(error);
    }
);
import { Toast } from "vant";
Toast.allowMultiple();
var Timer = null;
// 响应拦截
service.interceptors.response.use(
    // 通过自定义code判定响应状态，也可以通过HTTP状态码判定
    response => {
      var isReg = false;
      var arr = [
        "is_have_user",
        "finger_lists",
        "success",
        "search",
        "reward",
        "seven_day",
      ];
      var url = response.config.url.slice(
        response.config.url.lastIndexOf("/") + 1
      );
  
      if (arr.indexOf(url) >= 0) {
        isReg = false;
      } else {
        isReg = true;
      }
  
      let { data } = response;
      setTimeout(()=>{
      if (Timer) {
        count = 0;
        clearInterval(Timer);
      }
      Toast.clear(true);
  
      },300)
      if (data.code == 200) {
          return Promise.resolve(data);
      } else if (data.result == "ID不能为空") {
      } else if (data.code == 10010) {
        //状态码10010  跳转链接，replace
        if (data.result.info) {
          Toast(data.result.info);
          setTimeout(() => {
            router.replace(data.result.url);
          }, 500);
        }
      } else {
        if (data.code != 10004 && isReg) {
          Toast.fail(data.result);
        }
      }
      // if (data.code == 200) {
      //   return Promise.resolve(data);
      // } else if (data.result == "ID不能为空") {
      // } else if (data.code == 603) {
      //   //不是微信登录
      //   sessionStorage.setItem("is_wx_login", "0");
  
      //   if (data.result) {
      //     Toast.fail(data.result);
      //   }
      //   store.state.isLogin = false;
      //   store.state.user = {};
      //   store.state.imreward = "";
      //   setTimeout(() => {
      //     toLogin();
      //   }, 3000);
      // } else if (data.code == 602 || data.code == 606 || data.code == 401) {
      //   //是微信登录
      //   if (data.result) {
      //     Toast.fail(data.result);
      //   }
      //   store.state.isLogin = false;
      //   store.state.user = {};
      //   store.state.imreward = "";
      //   setTimeout(() => {
      //     toLogin();
      //   }, 3000);
      // } else if (data.code == 604) {
      //   //小程序登录验证失败 uid和user_key 直接跳转小程序登录页
      //   localStorage.removeItem("applets_uid");
      //   localStorage.removeItem("applets_user_key");
  
      //   wx.miniProgram.navigateTo({
      //     url: `/pages/login/login?final_link=${router.currentRoute.fullPath}`,
      //   });
      // } else if (data.code == 10007) {
      //   Toast.fail(data.result);
      //   setTimeout(() => {
      //     router.go(-1);
      //   }, 3000);
      // } else if (data.code == 10008) {
      //   //微信插件未开启或是微信自动登录关闭
      //   if (data.result.info) {
      //     Toast.fail(data.result.info);
      //     setTimeout(() => {
      //       router.push(data.result.url);
      //     }, 3000);
      //   } else {
      //     if (data.result.url.substring(0, 4) == "http") {
      //       if (
      //         sessionStorage.getItem("is_XcX") &&
      //         !sessionStorage.getItem("isiOS") &&
      //         fnc.isWx()
      //       ) {
      //         window.location.href =
      //           window.location.origin + "/#" + data.result.url + "&VNK=b0277841";
      //       } else {
      //         window.location.href = data.result.url;
      //       }
      //     } else {
      //       router.push(data.result.url);
      //     }
      //   }
      // } else if (data.code == 10010) {
      //   //状态码10010  跳转链接，replace
      //   if (data.result.info) {
      //     Toast(data.result.info);
      //     setTimeout(() => {
      //       router.replace(data.result.url);
      //     }, 500);
      //   }
      // } else {
      //   if (data.code != 10004 && isReg) {
      //     Toast.fail(data.result);
      //   }
      // }
      return Promise.resolve(data);
    },
    (error) => {
      if (Timer) {
        count = 0;
        clearInterval(Timer);
      }
      Toast.clear(true);
      if (error.response) {
        switch (error.response.status) {
          case 401:
            break;
          case 403:
            toLogin();
            break;
  
          // 404请求不存在
          case 404:
            break;
  
          default:
          // Toast.fail("网络错误，请重试！");
        }
      }
      return Promise.reject(error.response);
    }
);

export default service;



// WEBPACK FOOTER //
// ./src/assets/js/api/http.js